import React, { useState } from "react";
import { toast } from "react-toastify";
import ComponentCard from "../../components/common/ComponentCard";
import PageMeta from "../../components/common/PageMeta";
import useGoBack from "../../hooks/useGoBack";
import SubscriptionPlanService from "../../services/subscription-plan.service";
import SubscriptionPlanForm from "./SubscriptionPlanForm";
import { SubscriptionPlanFormData, SubscriptionPlanFormErrors } from "./types";
import {
  buildPlanPayload,
  defaultPlanFormData,
  validatePlanForm,
} from "./subscriptionPlanFormUtils";

export default function CreateSubscriptionPlan() {
  const [formData, setFormData] =
    useState<SubscriptionPlanFormData>(defaultPlanFormData);
  const [errors, setErrors] = useState<SubscriptionPlanFormErrors>({});
  const [isLoading, setIsLoading] = useState(false);
  const goBack = useGoBack();

  const handleChange = (
    field: keyof SubscriptionPlanFormData,
    value: string | boolean
  ) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleCreate = async () => {
    const nextErrors = validatePlanForm(formData);
    setErrors(nextErrors);
    if (Object.values(nextErrors).some(Boolean)) return;

    setIsLoading(true);
    try {
      const response = await SubscriptionPlanService.createPlan(
        buildPlanPayload(formData)
      );
      if (response.data?.status === 200 || response.status === 201) {
        toast.success("Subscription plan created successfully!");
        setTimeout(() => {
          window.location.href = "/list-subscription-plans";
        }, 1000);
      }
    } catch (err) {
      console.error("Error creating subscription plan:", err);
      toast.error("Failed to create subscription plan. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div>
      <PageMeta
        title="VIYUME - Create Subscription Plan"
        description="Create Subscription Plan"
      />
      <div className="mx-auto max-w-[80%] grid grid-cols-1 gap-6">
        <ComponentCard title="">
          <SubscriptionPlanForm
            data={formData}
            errors={errors}
            isLoading={isLoading}
            submitLabel="Create"
            loadingLabel="Creating..."
            onChange={handleChange}
            onCancel={goBack}
            onSubmit={handleCreate}
          />
        </ComponentCard>
      </div>
    </div>
  );
}
